import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import { shufflaa, shufflaaKuvat } from '../../utils/randomize'
import { data } from './data/data_03_wtw.js'

// import kuva1 from './images/walk_ok.png'
import kuva1 from './images/walk_3piste.gif'
import kuva2 from './images/walk_2piste.gif'
import kuva3 from './images/walk_4piste.gif'
import kuva4 from './images/walk_hyppy.gif'



const WTW = ({ scoreHandler, visibilityHandler, soundsOn, trials, addTrial }) => {

    const [teksti, setTeksti] = useState('')
    const [vastaus, setVastaus] = useState('')
    const [oikeaVastaus, setOikeaVastaus] = useState('')
    const [yritystenLkm, setYritystenLkm] = useState(0)
    const [sKuva1, setSKuva1] = useState({})
    const [sKuva2, setSKuva2] = useState({})
    const [sKuva3, setSKuva3] = useState({})
    const [sKuva4, setSKuva4] = useState({})
    const [order2, setOrder2] = useState([])

    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {
        setOrder2(shufflaa([1, 2, 3, 4]))//kuvajärjestyksen randomointi
        //    setTeksti(data.osatehtava1)
        //    setOikeaVastaus(data.apv_nimi)
    }, [])


    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);


    //kuvien shufflaus
    let arr1
    let arr2
    let arr3
    let arr4

    useEffect(() => {

        if (order2.length != 0) {
            arr1 = shufflaaKuvat(order2, 0, [kuva1, kuva2, kuva3, kuva4])
            arr2 = shufflaaKuvat(order2, 1, [kuva1, kuva2, kuva3, kuva4])
            arr3 = shufflaaKuvat(order2, 2, [kuva1, kuva2, kuva3, kuva4])
            arr4 = shufflaaKuvat(order2, 3, [kuva1, kuva2, kuva3, kuva4])
            setSKuva1({ kuva: arr1[0], alt: arr1[1] })
            setSKuva2({ kuva: arr2[0], alt: arr2[1] })
            setSKuva3({ kuva: arr3[0], alt: arr3[1] })
            setSKuva4({ kuva: arr4[0], alt: arr4[1] })

        }
    }, [order2])


    //ja kuvien asettelu pielessä jos menevät mainin alareunan alle. 

    const klikattuKuvaa = (e) => {

        addTrial()

        if (e.target.alt == 1) {//3-piste
            if (trials > 0) {
                data.optiot[0].pisteet = 0
            }

            scoreHandler(data.optiot[0], data.scene, data.maxp)
            visibilityHandler('kävelytekniikka ok')//--> siirrytään portaisiin väliscenen kautta
        }
        else if (e.target.alt == 2) {//2-piste
            scoreHandler(data.optiot[1], data.scene, data.maxp)
            alert('ei näin, koeta uudelleen')
        }
        else if (e.target.alt == 3) {//4-piste
            scoreHandler(data.optiot[2], data.scene, data.maxp)
            alert('ei näin, koeta uudelleen')
        }
        else if (e.target.alt == 4) {//hyppy
            scoreHandler(data.optiot[3], data.scene, data.maxp)
            alert('ei näin, koeta uudelleen')
        }
        else if (trials > 0) {

        }


    }

    return (
        <div className='wtwContainer'>

            {/* <div id='toppi'>toppi</div> */}

            <div id='kys'><h4>{(data.kysymysteksti != null && data.kysymysteksti != "") ? data.kysymysteksti : null}</h4></div>

            <img id='a' src={sKuva1.kuva} alt={sKuva1.alt} onClick={(e) => klikattuKuvaa(e)} />
            <img id='b' src={sKuva2.kuva} alt={sKuva2.alt} onClick={(e) => klikattuKuvaa(e)} />
            <img id='c' src={sKuva3.kuva} alt={sKuva3.alt} onClick={(e) => klikattuKuvaa(e)} />
            <img id='d' src={sKuva4.kuva} alt={sKuva4.alt} onClick={(e) => klikattuKuvaa(e)} />

            {/* <div id='bot'>bottomi</div> */}

        </div>

    )







}

export default WTW